import React, { memo, ReactNode } from "react";
import {
  StyledEntityContainer,
  StyledEntityGroup,
  StyledGroupScore,
  StyledVerticalGroup,
  StyledEntityName,
} from "./Entity.styled";
import Tooltip from "../../Tooltip";
import useOverflow from "../../../hooks/useOverflow";

import Avatar from "../../Avatar";
import { TypesValue } from "../../Avatar/Avatar";
import { Entity } from "../types";

export const EntityName = memo(({ name }: { name: string }) => {
  const { isOverflowing, ref } = useOverflow();

  return (
    <Tooltip title={isOverflowing ? name : ""} followCursor>
      <StyledEntityName ref={ref}>{name}</StyledEntityName>
    </Tooltip>
  );
});

export const EntityRow = memo(
  ({
    name,
    avatarSrc,
    type,
  }: {
    name: string;
    avatarSrc: string;
    type: string;
  }) => {
    return (
      <StyledEntityContainer>
        <Avatar
          alt={name}
          src={avatarSrc}
          type={type as TypesValue}
          size="medium"
        />
        <EntityName name={name} />
      </StyledEntityContainer>
    );
  },
);

export const EntitiesGroup = memo(
  ({ entities, score }: { entities: Entity[]; score: ReactNode }) => {
    return (
      <StyledVerticalGroup>
        <StyledEntityGroup>
          {entities.map((entity, entityIndex) => (
            <EntityRow
              key={entity.id || entityIndex}
              name={entity.name}
              avatarSrc={entity.avatarSrc || ""}
              type={entity.type}
            />
          ))}
        </StyledEntityGroup>
        {score && <StyledGroupScore>{score}</StyledGroupScore>}
      </StyledVerticalGroup>
    );
  },
);
